import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import * as DOMPurify from 'dompurify';
import { beautifyAndHighlightValue, copyToClipboard, getTextFromHtml } from "helpers/Integrations/req_res_text_area_helper";

// Always send value in string format
const ReqResTextarea = ({ isBeautify = true, key, val }) => {

    const copyIconHtml = (val) => {
        return (
            <>
                <i id={`copy-text-${key}`} onClick={() => copyToClipboard(val)} className={`bx bx-copy fs-16 me-2 mt-1 align-icon-top-right color-copy-icon`}></i>
                <UncontrolledTooltip placement="top" target={`copy-text-${key}`}>
                    Copy
                </UncontrolledTooltip>
            </>
        )
    }

    return (
        <div className='int-logs-req-res-body p-1' style={{ position: 'relative' }}>
            {
                isBeautify ?
                    <>
                        <code style={{ whiteSpace: "pre-wrap", color: "#fff" }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(beautifyAndHighlightValue(val)) }}></code>
                        {copyIconHtml(getTextFromHtml(beautifyAndHighlightValue(val)))}
                    </> :
                    <>
                        <code style={{ whiteSpace: "pre-wrap", color: "#fff" }}>{val}</code>
                        {copyIconHtml(val)}
                    </>
            }
        </div>
    )
}

export default ReqResTextarea;